export default __webpack_public_path__ + "static/media/arm_shield+pc@2x.542abef8.png";